module.exports = __webpack_public_path__ + "media/educators/ClickToContactUs4-ad2d30c2.png";